import {defineBrand, type Suggestion} from '@livingdata/playground-core-front'
import {CharterNotice} from '../components/charter-notice'
import {CreditExhaustedNotice} from '../components/credit-exhausted-notice'
import {SubscriptionManagedNotice} from '../components/subscription-managed-notice'
import {GeopromptLogo} from './logo'

// The two suggestions that present the agent are read first, for a visitor who
// has no question yet: onboarding, which starts from what their work involves,
// then what the agent can do. The catalog ones follow, for whoever is ready to
// ask something of their own.
const suggestions: Suggestion[] = [
  {id: 'onboarding', i18nKey: 'suggestions.onboarding', icon: 'compass'},
  {id: 'capabilities', i18nKey: 'suggestions.capabilities', icon: 'wand'},
  {id: 'catalog', i18nKey: 'suggestions.catalog', icon: 'library'},
  {id: 'thematicSearch', i18nKey: 'suggestions.thematicSearch', icon: 'lightbulb'}
]

export const brand = defineBrand({
  name: 'Geoprompt',
  Logo: GeopromptLogo,
  suggestions,
  HomeOutlet: CharterNotice,
  CreditExhaustedNotice,
  SubscriptionManagedNotice
})
